import { render, staticRenderFns } from "./UserLogout.vue?vue&type=template&id=6ba24156&scoped=true"
import script from "./UserLogout.vue?vue&type=script&lang=js"
export * from "./UserLogout.vue?vue&type=script&lang=js"
import style0 from "./UserLogout.vue?vue&type=style&index=0&id=6ba24156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba24156",
  null
  
)

export default component.exports